import React from 'react';

type Props = {
  title: string;
  titleId?: string;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  /** When false, backdrop clicks do not close (e.g. while submitting). */
  closeOnBackdrop?: boolean;
};

/** Shared compact shell for destructive confirmation modals. */
export default function ConfirmDestructiveDialog({
  title,
  titleId = 'confirm-destructive-title',
  onClose,
  children,
  footer,
  className,
  closeOnBackdrop = true,
}: Props) {
  return (
    <div
      className="modal-backdrop"
      onClick={closeOnBackdrop ? onClose : undefined}
      role="presentation"
    >
      <div
        className={['modal', 'card', 'card-elevated', 'confirm-destructive-dialog', className]
          .filter(Boolean)
          .join(' ')}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        data-testid="confirm-destructive-dialog"
      >
        <h2 id={titleId}>{title}</h2>
        <div className="confirm-destructive-dialog__body">{children}</div>
        {footer ? (
          <div className="modal-actions confirm-destructive-dialog__actions">{footer}</div>
        ) : null}
      </div>
    </div>
  );
}
